import React from 'react';

import { H4, Paragraph } from 'components/core/Typography';
import { TooltipWithClickOutside } from 'components/core/Tooltip';
import { Image } from 'components/core/Image';
import TooltipIcon from 'components/svg/TooltipInfo';

import garageClickIcon from 'assets/images/icons/online-garage-click.svg';

import './OmiBanner.scss';

export default function OmiBanner() {
	return (
		<div className="omi-banner">
			<TooltipWithClickOutside
				content="Complete your rental process online today and go straight to your unit when you plan to move in."
				plainText
				fillParentContainer
			>
				<div className="banner-content">
					<Image
						alt="garage icon"
						src={garageClickIcon}
					/>
					<div className="banner-text">
						<H4
							last
							color="orange"
							weight="standard"
						>
							Rent online today & skip the office when moving in
							<TooltipIcon className="hide-for-desktop" />
						</H4>
						<Paragraph
							last
							weight="standard"
							className="hide-for-mobile description"
						>
							Complete your rental process online today and go
							straight to your unit when you plan to move in.
						</Paragraph>
					</div>
				</div>
			</TooltipWithClickOutside>
		</div>
	);
}
